import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import t from 'format-message';
import { View } from '@instructure/ui-view';
import { Flex } from '@instructure/ui-flex';
import { IconButton } from '@instructure/ui-buttons';
import { ScoreWithLabel } from "./ScoreWithLabel.js";
export var ScoreCellContent = function ScoreCellContent(_ref) {
  var masteryLevel = _ref.masteryLevel,
    scoreDisplayFormat = _ref.scoreDisplayFormat,
    score = _ref.score,
    totalScore = _ref.totalScore,
    label = _ref.label,
    iconColor = _ref.iconColor,
    onAction = _ref.onAction,
    actionScreenReaderLabel = _ref.actionScreenReaderLabel,
    actionIcon = _ref.actionIcon,
    focus = _ref.focus,
    hoverControlled = _ref.hover,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'primary' : _ref$background;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hoverInternal = _useState2[0],
    setHoverInternal = _useState2[1];
  var hover = hoverControlled !== null && hoverControlled !== void 0 ? hoverControlled : hoverInternal;
  var showAction = onAction && (focus || hover);
  var handleMouseEnter = function handleMouseEnter() {
    if (hoverControlled === void 0) {
      setHoverInternal(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (hoverControlled === void 0) {
      setHoverInternal(false);
    }
  };
  return /*#__PURE__*/React.createElement(View, {
    as: "div",
    background: background,
    height: "100%",
    position: "relative",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-testid": "score-cell-content"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    shouldGrow: true,
    padding: "xx-small 0"
  }, /*#__PURE__*/React.createElement(ScoreWithLabel, {
    masteryLevel: masteryLevel,
    score: score,
    totalScore: totalScore,
    scoreDisplayFormat: scoreDisplayFormat,
    label: label,
    iconColor: iconColor
  }))), onAction && /*#__PURE__*/React.createElement("div", {
    "data-testid": "score-cell-action-wrapper",
    style: {
      opacity: showAction ? 1 : 0,
      pointerEvents: showAction ? 'auto' : 'none'
    }
  }, /*#__PURE__*/React.createElement(View, {
    position: "absolute",
    insetInlineEnd: "0",
    insetBlockStart: "50%",
    style: {
      transform: 'translateY(-50%)'
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-haspopup": "dialog",
    withBackground: false,
    withBorder: false,
    size: "small",
    margin: "0 xxx-small 0 0",
    renderIcon: actionIcon,
    screenReaderLabel: actionScreenReaderLabel || t('View Contributing Score Details'),
    onClick: onAction,
    "data-testid": "score-cell-action-button"
  }))));
};